export default "__VITE_ASSET__DIT7dl9G__"